class SliderVs extends HTMLElement {
    constructor() {
        super();
      
    }  
    
    connectedCallback() {
        this.initSlider();
    }

    initSlider() {
        this.swiper = new Swiper('.swiper-vs', {
            slidesPerView: 1.1,
            spaceBetween: 6,
            centeredSlides: true,
            initialSlide: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
              700: {
                slidesPerView: 1.8,
                spaceBetween: 6,
                centeredSlides: false,
              },
              989: {
                slidesPerView: 3,
                spaceBetween: 18,
                centeredSlides: false,
              }
            }
          });
    }
}

customElements.define('slider-vs', SliderVs);